export { InternalMessageBusChannels } from "./InternalMessageBus";
import { InternalMessageBus } from "./InternalMessageBus";
export var internalMessageBus = new InternalMessageBus();
//# sourceMappingURL=index.js.map